/** @format */

import React from "react";

const headerSortingStyle = { backgroundColor: "#f6f9fc" };

import UserNameHover from "components/userNameHover/ToUser";
import AppNameHover from "components/appNameHover/Hover";

export const columns = [
  {
    dataField: "id",
    text: "No",
    sort: true,
    headerSortingStyle,
    align: "center",
    headerAlign: "center",
    formatter: (cellContent, row, index) => {
      return <div>{index + 1}</div>;
    },
    style: {
      fontSize: "13px",
      color: "#888",
    },
    headerStyle: () => {
      return { width: "10%" };
    },
  },
  {
    dataField: "status",
    text: "상태",
    sort: true,
    align: "center",
    headerAlign: "center",
    style: {
      fontWeight: "bold",
      color: "#5395ff",
      fontSize: "13px",
    },
    headerStyle: () => {
      return { width: "10%" };
    },
  },
  {
    dataField: "appName",
    text: "앱 이름",
    sort: true,
    align: "left",
    headerAlign: "center",
    formatter: (cellContent, row) => {
      return <div>{row ? <AppNameHover row={row} /> : ""}</div>;
    },
    style: {
      fontSize: "13px",
      color: "#333",
    },
    headerStyle: () => {
      return { width: "25%" };
    },
  },
  {
    dataField: "title",
    text: "제목",
    sort: true,
    align: "left",
    headerAlign: "center",
    style: {
      fontSize: "13px",
      color: "#333",
      lineHeight: "1.7",
    },
    headerStyle: () => {
      return { width: "30%" };
    },
    formatter: (cellContent) => {
      return <div className="truncate-2-lines">{cellContent}</div>;
    },
  },
  // FIXME : [예진 -> 예지] email이 아닌 등록된 사용자 아이디로 수정해야합니다. 이건 어드민을 제외한 전체 페이지 동일하게 적용됩니다.
  // FIXME : 사용자가 다른사용자의 개인정보를 확인 할 수 없도록 하기 위함 입니다.
  {
    dataField: "email",
    text: "작성자",
    sort: true,
    align: "center",
    headerAlign: "center",
    headerStyle: () => {
      return { width: "15%" };
    },
    formatter: (cellContent) => {
      return (
        <div className="flex flex-col">
          <div className="app-hover">{cellContent ? <UserNameHover email={cellContent} /> : ""}</div>
        </div>
      );
    },
  },
  {
    dataField: "createdAt",
    text: "문의일",
    sort: true,
    align: "right",
    headerAlign: "center",
    style: {
      fontSize: "12px",
      color: "#333",
      lineHeight: "1.7",
    },
    headerStyle: () => {
      return { width: "10%" };
    },
  },
];
